export default __webpack_public_path__ + "img/e3b1f7abd6551abc23f5fb658e4d44da.png";